import { Button } from '@/components/ui';
import styles from './NotFoundPage.module.css';

/**
 * 404 Not Found page.
 */
export function NotFoundPage() {
  return (
    <main className={styles.page}>
      <div className={styles.content}>
        <h1 className={styles.code}>404</h1>
        <h2 className={styles.title}>Página não encontrada</h2>
        <p className={styles.description}>
          A página que você está procurando não existe ou foi movida.
        </p>
        <a href="/">
          <Button variant="primary">Voltar para o início</Button>
        </a>
      </div>
    </main>
  );
}
